function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".avatar_svg__st0{fill:#020202}");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "avatar_svg__st0",
  d: "M19.9 19.4c-.9-.2-2-.4-2.7-1.4-.1-.1-.6-.8.5-2.1 1-1.2.7-3.1.7-3.6-.2-1-1.2-1.8-2.4-1.8s-2.2.8-2.4 1.8c-.1.6-.3 2.5.7 3.6 1.2 1.3.6 2 .5 2.2-.8.9-1.8 1.1-2.7 1.3-.5.1-1 .2-1.4.5-.6.4-.7 1.1-.7 1.6h12c0-.5-.1-1.2-.7-1.6-.4-.3-.9-.4-1.4-.5z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "avatar_svg__st0",
  d: "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm6.9 22.1c0 .2-.2.4-.5.4H9.5c-.2 0-.5-.2-.5-.4 0-.1-.3-2.1 1.1-3 .5-.4 1.2-.5 1.8-.6.8-.2 1.6-.3 2.1-1 0 0 .1-.2-.5-.9-1.3-1.5-1-3.8-.9-4.5.3-1.5 1.7-2.6 3.4-2.6s3.1 1.1 3.4 2.6c.1.7.4 3-.9 4.5-.5.6-.5.9-.5.9.5.6 1.3.8 2.1 1 .6.1 1.2.3 1.8.6 1.3.9 1 2.9 1 3z"
});

var SvgAvatar = function SvgAvatar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return React.createElement("svg", _extends({
    id: "avatar_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    height: size,
    width: size
  }, props), _ref2, _ref3, _ref4);
};

export default SvgAvatar;